module.exports = __webpack_public_path__ + "img/background_startscreen.8a48f584.jpg";